//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { padZero } from '../utils/format/string'
import { range } from '../utils/format/number'
import { times } from './utils'
export default {
  name: 'MZTimePicker',
  props: {
    show: Boolean,
    title: String,
    loading: Boolean,
    itemHeight: [Number, String],
    showToolbar: Boolean,
    cancelButtonText: String,
    confirmButtonText: String,
    allowHtml: {
      type: Boolean,
      default: true
    },
    visibleItemCount: {
      type: [Number, String],
      default: 5
    },
    swipeDuration: {
      type: [Number, String],
      default: 1000
    },
    value: null,
    filter: Function,
    formatter: {
      type: Function,
      default: (type, value) => value
    },
    columnsOrder: Array,
    minHour: {
      type: [Number, String],
      default: 0
    },
    maxHour: {
      type: [Number, String],
      default: 23
    },
    minMinute: {
      type: [Number, String],
      default: 0
    },
    maxMinute: {
      type: [Number, String],
      default: 59
    }
  },
  data() {
    return {
      innerValue: this.formatValue(this.value)
    }
  },
  computed: {
    ranges() {
      return [
        {
          type: 'hour',
          range: [+this.minHour, +this.maxHour]
        },
        {
          type: 'minute',
          range: [+this.minMinute, +this.maxMinute]
        }
      ]
    },
    originColumns() {
      return this.ranges.map(({ type, range: rangeArr }) => {
        let values = times(rangeArr[1] - rangeArr[0] + 1, index => {
          const value = padZero(rangeArr[0] + index)
          return value
        })

        if (this.filter) {
          values = this.filter(type, values)
        }

        return {
          type,
          values
        }
      })
    },

    columns() {
      return this.originColumns.map(column => ({
        values: column.values.map(value => this.formatter(column.type, value))
      }))
    }
  },

  watch: {
    columns: 'updateColumnValue',
    filter: 'updateInnerValue',
    minHour: 'updateInnerValue',
    maxHour: 'updateInnerValue',
    minMinute: 'updateInnerValue',
    maxMinute: 'updateInnerValue',
    innerValue(val) {
      this.$emit('input', val)
    },
    value(val) {
      val = this.formatValue(val)

      if (val !== this.innerValue) {
        this.innerValue = val
        this.updateColumnValue()
      }
    }
  },
  mounted() {
      this.props = this.$parent.$props
      console.log(this.$parent.$props,this.props)
    this.updateColumnValue()

    this.$nextTick(() => {
      this.updateInnerValue()
    })
  },
  methods: {
    getPicker() {
      return this.$refs.picker
    },

    onConfirm() {
      this.$emit('confirm', this.innerValue)
    },

    onCancel() {
      this.$emit('cancel')
    },
    formatValue(value) {
      if (!value) {
        value = `${padZero(this.minHour)}:${padZero(this.minMinute)}`
      }

      let [hour, minute] = value.split(':')
      hour = padZero(range(hour, this.minHour, this.maxHour))
      minute = padZero(range(minute, this.minMinute, this.maxMinute))

      return `${hour}:${minute}`
    },

    updateInnerValue() {
      const [hourIndex, minuteIndex] = this.getPicker().getIndexes()
      const [hourColumn, minuteColumn] = this.originColumns

      const hour = hourColumn.values[hourIndex] || hourColumn.values[0]
      const minute = minuteColumn.values[minuteIndex] || minuteColumn.values[0]

      this.innerValue = this.formatValue(`${hour}:${minute}`)
      this.updateColumnValue()
    },

    onChange(picker) {
      this.updateInnerValue()

      this.$nextTick(() => {
        this.$nextTick(() => {
          this.$emit('change', picker)
        })
      })
    },

    updateColumnValue() {
      const pair = this.innerValue.split(':')
      const values = [
        this.formatter('hour', pair[0]),
        this.formatter('minute', pair[1])
      ]

      this.$nextTick(() => {
        this.getPicker().setValues(values)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/_mengzhua-ui@1.1.4@mengzhua-ui/components/dateTimePicker/timePicker.vue